import { deburr, flatten, groupBy } from 'lodash-es'

export const groupValuationsCallback = valuationList => {
  const valuation = [...valuationList]
  const yearly = Object.entries(groupBy(valuation, 'year'))
  const grouped = flatten(
    yearly.map(item => {
      const year = Number(item[0])
      const monthly = Object.entries(groupBy(item[1], 'month'))
      return monthly.map(month => ({
        year,
        month: month[0],
        monthNumber: month[1][0].monthNumber,
        valuations: month[1],
      }))
    }),
  ).sort((a, b) => {
    return (
      a.year - b.year ||
      a.valuations[0].monthNumber - b.valuations[0].monthNumber
    )
  })
  return grouped.slice(-3)
}

export const searchedValuations = (value, valuations) => {
  const parsedValue = deburr(value.toLowerCase())
  const searched = valuations.filter(valuation => {
    const address = deburr(valuation.fullAddress).toLowerCase()
    const categories = deburr(valuation.subCategory.join(' ')).toLowerCase()
    const area = String(valuation.area || '')
    const sqrMtrPrice = String(valuation.sqrMeterPrice || '')
    const garages = String(valuation.garages || '')
    const bedrooms = String(valuation.bedrooms || '')
    const suites = String(valuation.suites || '')
    const date = `${valuation.year}/${valuation.monthNumber}/${valuation.day}-${valuation.month}`
    const status = deburr(valuation.status).toLowerCase()

    return (
      categories.includes(parsedValue) ||
      date.includes(parsedValue) ||
      suites.includes(parsedValue) ||
      status.includes(parsedValue) ||
      address.includes(parsedValue) ||
      sqrMtrPrice.includes(parsedValue) ||
      garages.includes(parsedValue) ||
      bedrooms.includes(parsedValue) ||
      area.includes(parsedValue)
    )
  })
  return searched
}
